import { alpha, ComponentsOverrides, Theme } from '@mui/material/styles';

export default function MuiMenuItem(theme: Theme): {
  MuiMenuItem: {
    styleOverrides: ComponentsOverrides<Theme>['MuiMenuItem'];
  };
} {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&:hover': {
            color: theme.palette.primary.main,
            background: alpha(theme.palette.primary.main, 0.05),
          },
        },
      },
    },
  };
}
